import React, {
    useState, useRef, useCallback,
} from 'react';
import styled from 'styled-components';
// Material UI
import Grid from '@mui/material/Grid';
import Slide from '@mui/material/Slide';
import ControlButton from './ControlButton';
import { useJQueryHandlers } from '../../ui_utils';

const ActionsBackground = styled(Grid)`
  position: absolute;
  overflow: hidden;
  height: auto;
  width: auto;
`;

/**
 * @todo Remove dependency on var(--mol-button-margin)
 */
export default function SpeedDial({
    control, ActionsBackgroundProps, ActionsContainerProps, children,
}) {
    // Tri-state open state lets us control both the drawer and tooltip with atomic setOpen calls.
    const [open, setOpen] = useState(''); // '', 'tooltip', 'drawer'
    const controlRef = useRef(null);
    const containerRef = useRef(null);

    const handleMouseLeave = useCallback(() => {
        // mouseleave: close both the drawer and the tooltip
        setOpen('');
    }, []);

    useJQueryHandlers(containerRef.current, { mouseleave: handleMouseLeave });

    const drawerOpen = open === 'drawer';
    const tooltipOpen = open === 'tooltip';

    // TODO: Consider investigating a way of supplying a custom control component without cloning.
    // The cloning allows you to add the necessary props: ref, onClick, TooltipProps.
    const controlComp = control ? React.cloneElement(control, {
        ref: controlRef,
        // Click: open/close the drawer, opening if the tooltip is visible
        onClick: () => { setOpen((old) => (old === 'drawer' ? '' : 'drawer')); },
        TooltipProps: {
            open: tooltipOpen,
            // Show/hide the tooltip, but do nothing if the drawer is open.
            onClose: () => { setOpen((old) => (old === 'tooltip' ? '' : old)); },
            onOpen: () => { setOpen((old) => (old === '' ? 'tooltip' : old)); },
        },
    }) : (
        <ControlButton
            ref={controlRef}
            // Click: open/close the drawer, opening if the tooltip is visible
            onClick={() => { setOpen((old) => (old === 'drawer' ? '' : 'drawer')); }}
            TooltipProps={{
                open: tooltipOpen,
                // Show/hide the tooltip, but do nothing if the drawer is open.
                onClose: () => { setOpen((old) => (old === 'tooltip' ? '' : old)); },
                onOpen: () => { setOpen((old) => (old === '' ? 'tooltip' : old)); },
            }}
        />
    );

    const rightOffset = controlRef.current?.offsetWidth ?? undefined;

    return (
        <Grid
            container
            sx={{ justifyContent: 'center', position: 'relative' }}
            className="buttonDrawer"
            onMouseLeave={handleMouseLeave}
            ref={containerRef}
        >
            {controlComp}
            { !!drawerOpen
            && (
                // TODO: Support slider animation on close (currently it just disappears)
                // Probably requires reorganzing the children so <Slider> is on the outside,
                // which probably requires specifying the offset (currently in ActionContainerProps)
                <ActionsBackground
                    sx={{ right: rightOffset != null ? `${rightOffset}px` : undefined }}
                    {...ActionsBackgroundProps}
                    container
                >
                    <Grid
                        container
                        {...ActionsContainerProps}
                        sx={[{ overflow: 'hidden' }, ActionsContainerProps?.sx]}
                    >
                        <Slide in={drawerOpen} direction="left">
                            <Grid
                                container
                                sx={{ width: 'auto' }}
                                wrap="nowrap"
                            >
                                {children}
                            </Grid>
                        </Slide>

                    </Grid>
                </ActionsBackground>
            )}
        </Grid>
    );
}
